(function () {
  'use strict';

  var menuToggle = document.querySelector('[data-mc-menu-toggle]');
  var mobileNav = document.querySelector('[data-mc-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var isOpen = !mobileNav.classList.contains('hidden');
      mobileNav.classList.toggle('hidden', isOpen);
      menuToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      var icon = menuToggle.querySelector('.material-symbols-outlined');
      if (icon) icon.textContent = isOpen ? 'menu' : 'close';
    });
  }

  document.querySelectorAll('details.accordion-item').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      var parent = details.parentElement;
      if (!parent) return;
      parent.querySelectorAll('details.accordion-item').forEach(function (other) {
        if (other !== details) other.open = false;
      });
    });
  });

  document.querySelectorAll('[data-mc-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-mc-thumb');
      var main = document.getElementById('ProductMainImage');
      if (src && main) main.src = src;
    });
  });

  var productJsonEl = document.querySelector('[data-mc-product-json]');
  var productForm = document.querySelector('[data-mc-product-form]');
  if (productJsonEl && productForm) {
    var product = JSON.parse(productJsonEl.textContent);
    var variantInput = productForm.querySelector('[data-mc-variant-id]');
    var priceEl = document.querySelector('[data-mc-product-price]');
    var addBtn = productForm.querySelector('[data-mc-add-to-cart]');
    var optionSelects = productForm.querySelectorAll('[data-mc-option]');

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      }
      return '₹' + (cents / 100).toFixed(0);
    }

    function getSelectedVariant() {
      var selectedOptions = Array.from(optionSelects).map(function (s) {
        return s.value;
      });
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return opt === selectedOptions[i];
        });
      });
    }

    function onVariantChange() {
      var variant = getSelectedVariant();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (!variant.available) {
          addBtn.innerHTML = 'Sold out';
        }
      }
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', onVariantChange);
    });
  }

  var carousel = document.querySelector('[data-mc-carousel]');
  if (carousel) {
    var carouselItems = carousel.querySelectorAll('.carousel-item');
    var currentIndex = Math.min(2, Math.max(0, carouselItems.length - 1));
    var prevBtn = document.getElementById('prevBtn');
    var nextBtn = document.getElementById('nextBtn');

    function readSize(attrMobile, attrDesktop, fallbackMobile, fallbackDesktop) {
      var desktop = window.matchMedia('(min-width: 768px)').matches;
      var raw = carousel.getAttribute(desktop ? attrDesktop : attrMobile);
      var parsed = parseInt(raw, 10);
      if (!isNaN(parsed)) return parsed;
      return desktop ? fallbackDesktop : fallbackMobile;
    }

    function updateCarousel() {
      if (!carouselItems.length) return;

      var centerW = readSize('data-center-w-mobile', 'data-center-w-desktop', 220, 380);
      var sideW = readSize('data-side-w-mobile', 'data-side-w-desktop', 180, 320);
      var farW = readSize('data-far-w-mobile', 'data-far-w-desktop', 160, 280);

      carouselItems.forEach(function (item, index) {
        item.className =
          'carousel-item absolute h-full z-10 transition-all duration-500 overflow-hidden shadow-lg blur-[2px]';
        item.style.width = '';
        item.style.transform = '';
        item.style.opacity = '';
        item.style.zIndex = '';

        var farLeft = (currentIndex - 2 + carouselItems.length) % carouselItems.length;
        var left = (currentIndex - 1 + carouselItems.length) % carouselItems.length;
        var right = (currentIndex + 1) % carouselItems.length;
        var farRight = (currentIndex + 2) % carouselItems.length;

        if (index === farLeft) {
          item.style.width = farW + 'px';
          item.style.transform = 'translateX(-60%) scale(0.75)';
          item.style.opacity = '0.4';
        } else if (index === left) {
          item.style.width = sideW + 'px';
          item.style.transform = 'translateX(-35%) scale(0.85)';
          item.style.opacity = '0.75';
          item.style.zIndex = '20';
          item.classList.remove('blur-[2px]');
          item.classList.add('shadow-xl');
        } else if (index === currentIndex) {
          var scalePct = parseInt(item.getAttribute('data-slide-scale'), 10);
          var scale = isNaN(scalePct) ? 1 : scalePct / 100;
          item.style.width = centerW + 'px';
          item.style.transform = 'scale(' + scale + ')';
          item.style.opacity = '1';
          item.style.zIndex = '30';
          item.classList.remove('blur-[2px]');
          item.classList.add('shadow-2xl', 'ring-1', 'ring-dark-brown/5');
        } else if (index === right) {
          item.style.width = sideW + 'px';
          item.style.transform = 'translateX(35%) scale(0.85)';
          item.style.opacity = '0.75';
          item.style.zIndex = '20';
          item.classList.remove('blur-[2px]');
          item.classList.add('shadow-xl');
        } else if (index === farRight) {
          item.style.width = farW + 'px';
          item.style.transform = 'translateX(60%) scale(0.75)';
          item.style.opacity = '0.4';
        } else {
          item.classList.add('hidden');
        }
      });
    }

    window.addEventListener('resize', function () {
      updateCarousel();
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        currentIndex = (currentIndex - 1 + carouselItems.length) % carouselItems.length;
        updateCarousel();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        currentIndex = (currentIndex + 1) % carouselItems.length;
        updateCarousel();
      });
    }

    updateCarousel();
  }

  document.querySelectorAll('[data-mc-dispensary-scroller]').forEach(function (scroller) {
    var autoplay = scroller.getAttribute('data-autoplay') === 'true';
    if (!autoplay) return;

    var intervalSeconds = parseInt(scroller.getAttribute('data-interval'), 10);
    var intervalMs = (isNaN(intervalSeconds) ? 4 : intervalSeconds) * 1000;
    var timer = null;
    var paused = false;

    function stepScroll() {
      if (paused) return;
      var firstCard = scroller.firstElementChild;
      var amount = firstCard ? firstCard.offsetWidth : Math.round(scroller.clientWidth * 0.6);
      var maxLeft = scroller.scrollWidth - scroller.clientWidth;
      var nextLeft = scroller.scrollLeft + amount;

      // If cards fit in a single row, rotate card order so movement is still visible.
      if (maxLeft <= 2) {
        if (firstCard && scroller.children.length > 1) {
          scroller.appendChild(firstCard);
        }
        return;
      }

      if (nextLeft >= maxLeft - 2) {
        scroller.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        scroller.scrollBy({ left: amount, behavior: 'smooth' });
      }
    }

    function start() {
      if (timer) clearInterval(timer);
      timer = setInterval(stepScroll, intervalMs);
    }

    scroller.addEventListener('mouseenter', function () {
      paused = true;
    });
    scroller.addEventListener('mouseleave', function () {
      paused = false;
    });
    scroller.addEventListener('touchstart', function () {
      paused = true;
    }, { passive: true });
    scroller.addEventListener('touchend', function () {
      paused = false;
    }, { passive: true });

    start();
  });

  document.querySelectorAll('[data-mc-image-rotate-enabled="true"]').forEach(function (grid) {
    var intervalSeconds = parseInt(grid.getAttribute('data-mc-image-rotate-interval'), 10);
    var intervalMs = (isNaN(intervalSeconds) ? 3 : intervalSeconds) * 1000;

    grid.querySelectorAll('[data-mc-rotating-image]').forEach(function (img) {
      var listRaw = img.getAttribute('data-media-list') || '';
      var list = [];
      try {
        list = JSON.parse(listRaw);
      } catch (e) {
        list = listRaw.split('|').filter(Boolean);
      }
      if (list.length <= 1) return;

      var index = 0;
      var timer = null;
      var card = img.closest('.group') || img.parentElement;

      function showNext() {
        var nextIndex = (index + 1) % list.length;
        var nextSrc = list[nextIndex];
        var clone = img.cloneNode(true);
        clone.removeAttribute('data-mc-rotating-image');
        clone.style.position = 'absolute';
        clone.style.inset = '0';
        clone.style.width = '100%';
        clone.style.height = '100%';
        clone.style.opacity = '0';
        clone.style.transition = 'opacity 500ms ease';
        clone.src = nextSrc;

        var container = img.parentElement;
        if (!container) return;
        container.style.position = 'relative';
        container.appendChild(clone);

        requestAnimationFrame(function () {
          clone.style.opacity = '1';
          img.style.transition = 'opacity 500ms ease';
          img.style.opacity = '0';
        });

        setTimeout(function () {
          img.src = nextSrc;
          img.style.opacity = '1';
          if (clone.parentElement) clone.parentElement.removeChild(clone);
        }, 520);

        index = nextIndex;
      }

      function start() {
        if (timer) clearInterval(timer);
        timer = setInterval(showNext, intervalMs);
      }

      function stop() {
        if (timer) clearInterval(timer);
      }

      if (card) {
        card.addEventListener('mouseenter', stop);
        card.addEventListener('mouseleave', start);
        card.addEventListener('touchstart', stop, { passive: true });
        card.addEventListener('touchend', start, { passive: true });
      }

      // sync starting index with currently rendered image url
      var currentSrc = img.getAttribute('src') || '';
      var normalizedCurrent = currentSrc.split('?')[0];
      for (var i = 0; i < list.length; i += 1) {
        if ((list[i] || '').split('?')[0] === normalizedCurrent) {
          index = i;
          break;
        }
      }

      start();
    });
  });
})();
